import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

const WidgetTypeCard = (props) => {
  const { title, icon, description, installNowlink, learnmoreLink } = props;

  const handleRefresh = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { section: "learn", learn: learnmoreLink },
    });
  };
  const openCreateWidgetModal = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { modal: { type: "create-widget" }, type: learnmoreLink },
    });
  };
  return (
    <article
      className="widget-type-card"
      onClick={() => {
        handleRefresh();
      }}
    >
      <SvgIcon src={icon} noFilterOnLight={true} />
      <div>
        <p className="s2">{title}</p>
        <p className="p5">{description}</p>
      </div>

      <SvgIcon
        classNames={"learn-more-button"}
        src={"/img/new-icons/add.svg"}
        onClickFn={(e) => {
          e.stopPropagation();
          openCreateWidgetModal();
        }}
      />
    </article>
  );
};
const LearnWidgetsList = ({ widgetTypesList }) => {
  /**
   * refresh the content with the learn query, to can detect that the user is in a learn more section
   */

  return (
    <aside className="mobile-hidden">
      <h4>Explore</h4>
      {widgetTypesList.map((w, i) => {
        return <WidgetTypeCard {...w} key={i} />;
      })}
    </aside>
  );
};
export default LearnWidgetsList;
